import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome'
import moment from 'moment';
import numeral from 'numeral';
import Pagination from 'react-js-pagination';
import Box from '../Layout/Box';
import ButtonStrip from '../Layout/ButtonStrip';
import BoxButton from '../Layout/BoxButton';
import history from '../../utils/history';
import ModalSelectorFromList from '../Shared/ModalSelectorFromList';
import ModalFilter from './ModalFilter';
import SelectorInput from '../Shared/SelectorInput';
import store from '../../utils/store';
import { changeNumberRegisterToShow, downloadFile, getMontoContratadoCenco, showHideModalFilter, updateInputs } from '../../actions/reportes';
import { showModalSelector, selectFromSelector } from '../../actions/common';
import { extractKeyValue } from '../../utils/helpers';

export function findValues(c, x) {
    const enums = store.getState().common.get('enums').toJS()
    let value = x.getIn(c.value.split('.'))
    if (c.value === 'estado') {
        value = enums.solicitudes.estados[value]
    } else if (c.value === 'tipo') {
        value = enums.solicitudes.tipos[value].caption
    }
    return value
}

class MontoContratadoCenco extends React.Component {

    handleOpenSelectorUsuarios = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/cencos', fn)
    }

    handleOpenSelectorCenco = (list) => {

        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripción', value: 'descripcion', width: '70%' }   
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = list
			payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES', payload)
        }
        const customFilter = { column: 'T0.responsable_id', operator: '===', value: this.props.reportes.getIn(['responsable', 'id']), comparison: 'string' }
        this.props.showModalSelector('Listado de CENCOS', columns, '/cencos', fn, customFilter)

    }



    handleClearCenco() {
        this.props.updateInputs('cenco', null)
        this.props.updateInputs('responsable', null)
    }

    newPageOfResults(page) {
        this.props.search(page);
    }

    downloadFile(type_report) {
        const url = '/reportes/download_monto_contratado_cenco';
        const params = {
            cenco_id: this.props.reportes.getIn(['cenco', 'id']),
            cenco_nombre: this.props.reportes.getIn(['cenco', 'descripcion']),
            responsable_id: this.props.reportes.getIn(['responsable', 'id']),
            responsable_nombre: this.props.reportes.getIn(['responsable', 'fullname']),
            fecha_inicio: this.props.reportes.getIn(['contracted_amount_cencos', 'initial_date']),
            fecha_fin: this.props.reportes.getIn(['contracted_amount_cencos', 'final_date']),
            filters: this.props.reportes.getIn(['contracted_amount_cencos', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS(),
            type_report
        };

        return this.props.downloadFile(url, params, type_report);
    }

    render() {
        const { reportes, enums, showRecords, totalRecords, page } = this.props;

        const tableCols = [
            { id: 1, caption: 'Cenco', value: 'cenco', type: 'string', format: '', width: '25%' },
            { id: 2, caption: 'Valor Comprado', value: 'cantidad_comprada', type: 'number', format: '$ 0,0[.]00', width: '25%' },
            { id: 3, caption: 'Valor ejecutado', value: 'valor_ejecutado', type: 'number', format: '$ 0,0[.]00', width: '25%' },
            { id: 4, caption: 'Valor comprometido', value: 'valor_comprometido', type: 'number', format: '$ 0,0[.]00', width: '25%' },
        ];
        const boxActions = [
            <BoxButton key="ba[0][0]" name="search" title="Buscar" onClick={e => this.newPageOfResults(1)} />,
            <BoxButton key="ba[0][1]" name="filter" onClick={ e => this.props.showHideModalFilter(true, tableCols) } title="Filtro"/>,
            <BoxButton key="ba[0][2]" name="file-excel-o" onClick={ e => this.downloadFile('xlsx') } title="Descargar excel"/>,
            <BoxButton key="ba[0][3]" name="file-pdf-o" onClick={ e => this.downloadFile('pdf') } title="Descargar PDF"/>,
        ];
        const pagination = <Pagination
            activePage={page}
            itemsCountPerPage={showRecords}
            totalItemsCount={totalRecords}
            pageRangeDisplayed={10}
            onChange={(pg) => this.newPageOfResults(pg)}
            firstPageText={<FontAwesome name="angle-double-left" />}
            prevPageText={<FontAwesome name="angle-left" />}
            nextPageText={<FontAwesome name="angle-right" />}
            lastPageText={<FontAwesome name="angle-double-right" />}
        />


        const formRequest = <div className="row" style={{padding:'0px'}}>

            <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label className="control-label">Dueño de cenco</label>
                    <SelectorInput
                        value={reportes.get('responsable') ? reportes.getIn(['responsable', 'fullname']) : ''}
                        onClick={() => this.handleOpenSelectorUsuarios('responsable')}
                        onReset={() => this.handleClearCenco()}
                    />
                </div>
            </div>


            <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label className="control-label">Cenco</label>
                    {
                        reportes.get('responsable') ? (

                            <SelectorInput
                            value={reportes.get('cenco') ? reportes.getIn(['cenco', 'descripcion']) : ''}
                            onClick={() => this.handleOpenSelectorCenco('cenco')}
                            onReset={() => this.props.updateInputs('cenco', null)}
                        />

                        ) : (
                            <input className="form-control input-sm" placeholder="Seleccione un responsable del cenco" disabled />
                        )
                    }

                </div>
            </div>


            <div className="col-md-2 col-sm-3 col-xs-12">
                <div className="form-group">
                    <label htmlFor="initial_date" className="control-label">Fecha Inicial</label>
                    <input type="date" className="form-control input-sm" name="initial_date"
                        value={reportes.getIn(['contracted_amount_cencos', 'initial_date'])}
                        onChange={(e) => this.props.updateInputs("contracted_amount_cencos.initial_date", e.target.value)} />
                </div>
            </div>


            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="final_date" className="control-label">Fecha Final</label>
                    <input type="date" className="form-control input-sm" name="final_date"
                        value={reportes.getIn(['contracted_amount_cencos', 'final_date'])}
                        onChange={(e) => this.props.updateInputs("contracted_amount_cencos.final_date", e.target.value)} />
                </div>
            </div>

        </div>



        return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: '100%' }}>


                    <Box title="Reporte monto contratado por cenco" stretch>


                        <ButtonStrip actions={boxActions} totalRecords={totalRecords}
                            showRecords={showRecords} pagination={pagination}
                            changeRecordsToShow={(records) => this.props.changeNumberRecordsToShow(records)}
                            formRequest = { formRequest }  
                        />

                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <div style={{ display: 'flex', height: '100%', justifyContent: 'space-between', flexDirection: 'column' }}>

                                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-evaluacion-proveedor">
                                    <thead>
                                        <tr>
                                            {
                                                tableCols.map(x => {
                                                    const style = { width: `${x.width}` }
                                                    return (
                                                        <th key={`th1[${x.id}]`} style={style}
                                                        >{x.caption}</th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            reportes.getIn(['contracted_amount_cencos', 'data']).size > 0 ? reportes.getIn(['contracted_amount_cencos', 'data']).map((x, index) => {
                                                return (
                                                    <tr key={`tr1[${x.get('proveedor_id')}${index}]`} className={x.get('selected') ? 'info' : ''}>
                                                        {
                                                            tableCols.map(c => {
                                                                let alignment = 'left'
                                                                let value = findValues(c, x)
                                                                if (c.type) {
                                                                    switch (c.type) {
                                                                        case 'datetime':
                                                                            value = value ? moment(value).format(c.format) : '';
                                                                            alignment = 'right';
                                                                            break
                                                                        case 'bool':
                                                                            if (typeof value === 'string') value = parseInt(value, 10)
                                                                            value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                            break
                                                                        case 'number':
                                                                            value = numeral(value).format(c.format)
                                                                            alignment = 'right'
                                                                            break
                                                                        default:
                                                                    }
                                                                }
                                                                const style = { textAlign: alignment }

                                                                if (c.LinkToEdit) {
                                                                    return (
                                                                        <td key={`td1[${x.get('id')}][${c.id}]`} className='LinkToEdit' style={style} onClick={e => history.push(window.FOLDER + `/solicitudes/${enums.solicitudes.tipos[x.get('tipo')].url}/${x.get('id')}`)}>{value}</td>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <td key={`td1[${x.get('id')}][${c.id}]`} style={style}>{value}</td>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={tableCols.length}>No existen registros</td></tr>
                                        }
                                    </tbody>
                                </table>

                            </div>
                        </div>


                    </Box>
                </div>
                <ModalSelectorFromList />
                <ModalFilter />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { reportes } = state;
    return {
        reportes,
        enums: state.common.get('enums').toJS(),
        showRecords: reportes.getIn(['contracted_amount_cencos', 'showRecords']),
        totalRecords: reportes.getIn(['contracted_amount_cencos', 'totalRecords']),
        page: reportes.getIn(['contracted_amount_cencos', 'page']),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        //getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols, 'contracted_amount_cencos')),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        changeNumberRecordsToShow: (number) => dispatch(changeNumberRegisterToShow(number, 'contracted_amount_cencos')),
        search: (page = 1) => dispatch(getMontoContratadoCenco(page)),
        downloadFile: (url, params, type) => dispatch(downloadFile(url, params, `Monto contratado por cenco.${type}`)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MontoContratadoCenco);


// WEBPACK FOOTER //
// ./src/components/Reportes/MontoContratadoCenco.jsx